import { render } from "./PrivasiDasar.vue?vue&type=template&id=f6d9ccbe"
import script from "./PrivasiDasar.vue?vue&type=script&lang=js"
export * from "./PrivasiDasar.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__